export default "__VITE_ASSET__xt5k$igG__ 1000w";